import LaborLawFinesTable from 'lib/common/Tables/LaborLawFinesTable';
import { LaborLawFinesConsult } from 'lib/types/models';
import React from 'react';

function LaborLawFinesResponse({
  consult,
}: {
  consult?: LaborLawFinesConsult;
}) {
  return <LaborLawFinesTable consult={consult} />;
}

export default LaborLawFinesResponse;
